import { useLocation, useParams } from 'react-router-dom';

import { useSubscription } from 'features/common/hooks/useSubscription';

export const useUprStatus = () => {
  const { upr_id } = useParams();
  const { pathname } = useLocation();
  const { subscription } = useSubscription();
  // const isNew = !upr_id || upr_id === 'new';
  // previosly upr_id was never 'new' and isNew was true for a project, not only upr
  const isNew = pathname.includes('/requests/new');
  const upr_data =
    !isNew &&
    subscription &&
    subscription.project_requests.filter((upr) => upr.hash_id === upr_id)[0];
  const isEditable =
    (isNew || upr_data?.status === 'DRAFT') && subscription?.user_is_sub_admin;
  return { isEditable, isNew };
};
